import { render, staticRenderFns } from "./OrganizationView.vue?vue&type=template&id=67bdad0a&scoped=true&"
import script from "./OrganizationView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationView.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationView.vue?vue&type=style&index=0&id=67bdad0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bdad0a",
  null
  
)

export default component.exports